module.exports = __webpack_public_path__ + "static/img/center.c6192a70.png";